import SubHeaders from '@/components/Headers/SubHeaders'
import { generatePathDatacentral, paths } from '@/utils/path'
import { useParams, useSearchParams } from 'react-router-dom'
import { Alert, Tabs } from 'vnetwork-ui'
import { READ_ONLY_VISIBLE_TABS, tabs } from './tabs'
import { useTranslation } from 'react-i18next'
import useTabs from '@/hooks/useTabs'
import { getCustomerById } from '../../services'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { useEffect } from 'react'
import { CustomerReadOnlyProvider } from './CustomerReadOnlyContext'

import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const Detail = () => {
    const { t } = useTranslation()
    const { id } = useParams()
    const [, setSearchParams] = useSearchParams()

    // Fetch customer details including status for conditional tab rendering
    const { data: customerData, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.CUSTOMERS, 'detail', id],
        queryFn: () => getCustomerById(Number(id)),
    })

    const customerStatus = customerData?.result?.customer_status
    const isReadOnly =
        customerData?.result?.viewer_access === 'lead_origin_readonly'
    const { TabComponent, TabProps, activeTab } = useTabs({
        tabs: tabs(t, customerStatus, isReadOnly),
    })

    // Chế độ chỉ xem: URL trỏ vào tab đã ẩn (vd ?tab=invoices) thì đưa về
    // basic-information, tránh vùng nội dung trắng. replace để nút Back không
    // quay lại đúng URL vừa bị chuyển hướng.
    const isHiddenTabActive =
        isReadOnly && !READ_ONLY_VISIBLE_TABS.includes(activeTab)
    useEffect(() => {
        if (!isHiddenTabActive) return
        setSearchParams(
            (prev) => {
                prev.set('tab', 'basic-information')
                return prev
            },
            { replace: true }
        )
    }, [isHiddenTabActive])

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <div>
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    {
                        path: paths.customersList,
                        title: t('customer_manager'),
                    },
                    {
                        path: generatePathDatacentral(paths.customerDetail, {
                            id,
                        }),
                        title: (() => {
                            const name = `${id} - ${customerData?.result?.customer_name}`
                            return name ? name.toUpperCase() : ''
                        })(),
                    },
                ]}
            />
            <div className="space-y-2">
                {isReadOnly && (
                    <Alert variant="info">
                        {t('customer:lead-origin-readonly-banner')}
                    </Alert>
                )}
                <div data-tour="customer-detail-tabs">
                    <Tabs {...TabProps} />
                </div>
                <CustomerReadOnlyProvider isReadOnly={isReadOnly}>
                    {TabComponent}
                </CustomerReadOnlyProvider>
            </div>
        </div>
    )
}

export default Detail
